import { flow, Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { bulkOnboardingFileDownload } from '../../network/bulkOnboardingFileDownload'
import { fetchUploadedExcelFileDetailWithId } from '../../network/fetchUploadedExcelFileDetailWithId'
import { submitFileForEntityCreation } from '../../network/submitFileForEntityCreation'
import { uploadedFileDetails } from '../../network/uploadedFileDetails'
import { getErrorMessage, MessageTypes } from '../../utils'
import { RootStore } from '../store'

const File = types.model('File', {
  filename: types.maybeNull(types.string),
  uploader: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  responseFile: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  accepted: types.maybeNull(types.number),
  declined: types.maybeNull(types.number),
  id: types.maybeNull(types.number),
})

const BulkEntity = types
  .model('BulkEntity', {
    id: types.number,
    uploadedExcelFileData: types.array(types.frozen()),
    fileName: types.string,
    files: types.array(File),
    uploadedFile: types.maybeNull(File),
    fileUploaded: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    resetUploadedFile() {
      self.uploadedFile = File.create({})
    },
    updateUploadedExcelFile(data: any) {
      try {
        self.uploadedExcelFileData = data
      } catch (error) {
        throw error
      }
    },
    updateFileName(fileName: string) {
      try {
        self.fileName = fileName
      } catch (error) {
        throw error
      }
    },
    submitFileForBulkEntityCreation: flow(function* submitFileForBulkEntityCreation(fileId: string, type: string) {
      try {
        const response = yield submitFileForEntityCreation(fileId, type, RootStore.session.getTokens)
        self.uploadedFile = response?.data
        self.uploadedFile.id = response?.data?.id
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    uploadedBulkFileDetails: flow(function* uploadedBulkFileDetails() {
      try {
        const response = yield uploadedFileDetails(RootStore.session.getTokens)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    fetchUploadedIndividualExcelFileDetail: flow(function* fetchUploadedIndividualExcelFileDetail() {
      try {
        const response = yield fetchUploadedExcelFileDetailWithId(RootStore.session.getTokens, 'ID_09873312')
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    downloadBulkOnboardingFile: flow(function* downloadBulkOnboardingFile(fileId: number, type: string) {
      try {
        const response = yield bulkOnboardingFileDownload(fileId, type, RootStore.session.getTokens)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getUploadedFileDetails() {
      return {
        fileName: self.uploadedFile.filename,
        processedDate: self.uploadedFile.createdAt,
        status: self.uploadedFile.status,
        actions: 'download_',
      }
    },
    getUploadedExcelFileData() {
      return self.uploadedExcelFileData
    },
    returnExcelFileName() {
      return self.fileName
    },
    getBulkUploadedFilesList() {
      const list = []
      self.files.map((file) => {
        list.push({
          id: file.id,
          name: file.filename,
          dataTime: file.updatedAt,
          status: file.status,
          actions:
            ((file?.type?.toLowerCase() === 'bulk_store' || file?.type?.toLowerCase() === 'bulk_terminal') &&
              file?.status?.toLowerCase() !== 'confirmed') ||
            file?.status?.toLowerCase() === 'completed'
              ? 'download_Download'
              : '-',
        })
      })
      return list
    },
  }))

const BulkEntityData = BulkEntity.create({
  id: 0,
  uploadedExcelFileData: [
    {
      asa: '123123',
      as: '123123',
    },
  ],
  fileName: 'abc',
})

export type BulkEntityType = Instance<typeof BulkEntity>
export { BulkEntity, BulkEntityData }
